// Shared types for the flow-map-first connection configuration UI.

export type FlowDirectionKey = "out" | "in";           // out = provider → destination
export type ArrowState = "enabled" | "disabled" | "not-enableable";

export type Selection =
    | { kind: "none" }
    | { kind: "account"; integrationId: string; section?: string }
    | { kind: "flow"; destinationId: string; direction: FlowDirectionKey; section?: string };

// Palette hexes duplicated from tailwind.config.js (connection-green, gray-lines):
// React Flow strokes and SVG markers are attributes, so Tailwind class names
// can't reach them. Single source for every flow-map SVG color.
export const FLOW_COLORS: Record<ArrowState, string> = {
    enabled: "#006842",
    disabled: "#cccccc",
    "not-enableable": "#cccccc",
};

export type AccountBundle = {
    id: string; name: string; base_url: string; status?: string;
    techName: string;                   // integration type name, e.g. "EarthRanger"
    techValue: string;                  // integration type value, e.g. "earth_ranger"
    actions: any[];                     // integration.type.actions (schema + ui_schema)
    configurations: any[];              // integration.configurations
    isProvider: boolean;
};
